import { useDispatch } from "react-redux";
import { confirmedSelection } from "../../store/slices/capsules-slice";
import ProgressBarMobile from "~/components/ProgressBarMobile/ProgressBarMobile.jsx";

import "./SelectedCapsulesList.css";

const SelectedCapsulesList = ({ selectedCapsules, handleQuantityChange, data }) => {
  const dispatch = useDispatch();

  return (
    <>
      {selectedCapsules.length > 0 && (
        <div className="popup-bottom">
          <div className="selected-capsules">
            <div className="selected-capsules-list">
              {selectedCapsules.map((capsule) => {
                const product = data.DynamicBox.selectableProductVariants.find(
                  (prod) => prod.productVariants[0].platformId === capsule.platformId
                );

                if (!product) return null;

                const variant = {
                  ...product.productVariants[0],
                  imageSrc: product.productImageSrc,
                };

                return (
                  <div key={capsule.platformId} className="selected-capsule-card">
                    <span
                      className="selected-capsule-remove"
                      onClick={() => handleQuantityChange(product, variant, 0)}>
                      X
                    </span>
                    <img src={variant.imageSrc} alt="Selected Capsule" />
                    <h4>{product.productTitle}</h4>
                    <span className="qty-bubble">{capsule.quantity}</span>
                  </div>
                );
              })}
            </div>
          </div>

          <ProgressBarMobile selectedCapsules={selectedCapsules} data={data} />

          <button className="confirm-selection" onClick={() => dispatch(confirmedSelection())}>
            Confirm Selection
          </button>
        </div>
      )}
    </>
  );
};

export default SelectedCapsulesList;
